import React, {useEffect, useState} from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import SimpleHeader from "../components/SimpleHeader";
import fetchImagesFromFolder from "../functions/fetchImagesFromFolder";
import PageTitle from "../components/PageTitle";

const Archive = () => {
    const [ images, setImages ] = useState([]);
    useEffect(() => {
        setImages(fetchImagesFromFolder('archive/', 25, 'archive-', "",  "jpg"));
    }, [setImages]);
    return (
        <>
            <PageTitle title='Archive' />
            <Header />
            <div className='main-container'>
                <SimpleHeader
                    title={"archive"}
                    route={"archive"}
                    url={"archive"}
                />
                <div className='archive-container max-w'>
                    { images.map((image, index) => (
                        <div className='archived-image' key={index}>
                            <img src={image} alt='' />
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Archive;